
























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";

import VueRouter from "vue-router";
import moment from "moment-timezone";
import { useDevinirTransferInKindStore } from "@/employee/store/devinirTransferInKind";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import * as SharedRoutes from "@/shared/route-names";

@Component({})
export default class DevinirNonCompliantAccountView extends Vue {
  $router: VueRouter;
  RouteNames = RouteNames;
  SharedRoutes = SharedRoutes;

  devinirTransferInKindStore = useDevinirTransferInKindStore();
  userStore = useUserStore();

  @Prop() routeToHome: string;
  @Prop() accountId: number;

  acknowledgeMessage (): void {
    this.devinirTransferInKindStore.setMessageAcknowledged(true);
    this.$router.push({ name: RouteNames.Home });
  }

  get transferInKindPeriodElapsed (): boolean {
    const dateNow = moment();
    const endDate = moment.tz("2025-07-18 16:00", "America/New_York");
    return dateNow.isAfter(endDate);
  }
}
